import { FormattedMessage } from 'react-intl'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TextButton from 'LuxKit/Button/TextButton'

export function ViewOfferButton(
  {
    variant,
    textOnly = false,
  }:
  {
    variant: 'default' | 'condensed'
    textOnly?: boolean
  },
) {
  if (textOnly) {
    return <FormattedMessage
      id="fmQoCma2QV_Cs2oKJd4k"
      defaultMessage="View offer"
      description="CTA text-only button label for viewing the full offer details on offer card listings"
    />
  }

  if (variant === 'default') {
    return <CSSBreakpoint min="desktop">
      <TextButton kind="primary" nonInteractable>
        <FormattedMessage
          id="QRWBrCWyrfw5EkB88Ukz"
          defaultMessage="View"
          description="Short CTA button label for viewing an offer on desktop in the default card variant"
        />
      </TextButton>
    </CSSBreakpoint>
  }

  return <TextButton kind="secondary" nonInteractable>
    <CSSBreakpoint as="span" max="tablet">
      <FormattedMessage
        id="D0v8mAmdy1sWaJg3dsiV"
        defaultMessage="View"
        description="Short CTA label on mobile to view offer details in the offer listing section"
      />
    </CSSBreakpoint>
    <CSSBreakpoint as="span" min="desktop">
      <FormattedMessage
        id="fmQoCma2QV_Cs2oKJd4k"
        defaultMessage="View offer"
        description="CTA text-only button label for viewing the full offer details on offer card listings"
      />
    </CSSBreakpoint>
  </TextButton>
}
